module.exports = __webpack_public_path__ + "assets/img/riqi.9a40aa99.png";